import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { alertTitles } from '../../../Model/Order/orderAlerts.ts'

/** A small warning sign on an action control with open alerts; nothing when it has none. */
export const AlertMarker = ({ items, className = 'w-4 h-4' }: { items: Array<{ title: string }>; className?: string }) =>
  items.length === 0 ? null : (
    <ExclamationTriangleIcon data-testid="alert-marker" className={`${className} text-amber-500 shrink-0`} title={alertTitles(items)} />
  )
